import { AdminUserEditPage } from "@/features/admin-user/pages/AdminUserEdit";

const AdminUserEdit = () => {
  return <AdminUserEditPage />;
};

export default AdminUserEdit;
